import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-luxury-black relative overflow-hidden">
      {/* Decorative Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(212, 175, 55, 0.1) 35px, rgba(212, 175, 55, 0.1) 70px)'
        }}></div>
      </div>

      <div className="container mx-auto px-6 lg:px-20 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1: Logo & Description */}
          <div className="text-right">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/1f06003d7503c3a2930527ba3c7a1f5f.jpeg"
                alt="فخامة الرفاهية"
                className="h-12 w-12 object-contain rounded-lg"
              />
              <div>
                <h3 className="text-gold font-almarai font-bold text-lg">فخامة الرفاهية</h3>
                <span className="text-white/70 font-cairo text-sm">للتوصيل</span>
              </div>
            </div>
            <p className="text-gray-400 font-cairo text-sm leading-relaxed">
              نقدم خدمات توصيل فاخرة من المطارات إلى مكة المكرمة والمدينة المنورة، مع التزامنا بتوفير أعلى مستويات الراحة والأمان للحجاج والمعتمرين.
            </p>
          </div>

          {/* Column 2: Newsletter */}
          <div className="text-right">
            <h4 className="text-white font-cairo font-semibold text-lg mb-4">اشترك في النشرة</h4>
            <form className="space-y-3">
              <div className="relative">
                <input
                  type="email"
                  placeholder="بريدك الإلكتروني"
                  className="w-full bg-transparent border-b-2 border-gold/50 text-white placeholder-gray-500 py-2 pr-0 pl-10 focus:outline-none focus:border-gold transition-colors font-cairo text-sm"
                />
                <button
                  type="submit"
                  className="absolute left-0 top-1/2 -translate-y-1/2 text-gold hover:text-gold-light transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-xl"></i>
                </button>
              </div>
              <p className="text-gray-500 text-xs font-cairo">
                بالاشتراك، أنت توافق على{' '}
                <a href="#" className="text-gold hover:underline">
                  سياسة الخصوصية
                </a>
              </p>
            </form>
          </div>

          {/* Column 3: Quick Links */}
          <div className="text-right">
            <h4 className="text-white font-cairo font-semibold text-lg mb-4">روابط سريعة</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-gold hover:mr-2 transition-all duration-300 font-cairo text-sm inline-block cursor-pointer"
                >
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-gold hover:mr-2 transition-all duration-300 font-cairo text-sm inline-block cursor-pointer"
                >
                  عن المؤسسة
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-400 hover:text-gold hover:mr-2 transition-all duration-300 font-cairo text-sm inline-block cursor-pointer"
                >
                  خدماتنا
                </Link>
              </li>
              <li>
                <Link
                  to="/booking"
                  className="text-gray-400 hover:text-gold hover:mr-2 transition-all duration-300 font-cairo text-sm inline-block cursor-pointer"
                >
                  احجز الآن
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-gold hover:mr-2 transition-all duration-300 font-cairo text-sm inline-block cursor-pointer"
                >
                  اتصل بنا
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Social Media */}
          <div className="text-right">
            <h4 className="text-white font-cairo font-semibold text-lg mb-4">تواصل معنا</h4>
            <div className="flex gap-3 justify-end">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-gray-800 hover:bg-gold rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-white text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-gray-800 hover:bg-gold rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-gray-800 hover:bg-gold rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-facebook-fill text-white text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 font-cairo text-sm text-center md:text-right">
              © {currentYear} فخامة الرفاهية للتوصيل. جميع الحقوق محفوظة.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-gold transition-colors font-cairo text-sm cursor-pointer"
            >
              Powered by AAIT
            </a>
          </div>
        </div>
      </div>

      {/* Large Decorative Text */}
      <div className="absolute bottom-0 right-0 left-0 h-44 flex items-center justify-center overflow-hidden opacity-5">
        <h2 className="text-luxury-cream font-almarai font-black text-9xl whitespace-nowrap">
          فخامة الرفاهية
        </h2>
      </div>
    </footer>
  );
};

export default Footer;
